import { handleHttpResponse } from "../../utils/http_response_utils";

export const getMasterCompanyNames = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-master-company-names", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getCompanyNamesAuto4client = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-company-names-auto4client", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getCompanyNamesCompJson = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-company-names-comp-json", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getJsonAvailableYears = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-json-available-years", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const generateClassifiedSheet = async (company, startDate, endDate, sheetName) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/generate-classified-sheet", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      company,
      start_date: startDate,
      end_date: endDate,
      sheet_name: sheetName,
    }),
  });
  return await handleHttpResponse(response);
};
